module.exports = __webpack_public_path__ + "videos/mts-products-chats-in-platform.9a4135a.webm";